const routes = {
    Home: '/',
    Lienhe: '/lienhe',
    Camnang: '/camnang',
    ViewTour: '/tours/:tourName/:tourId',
    CheckOut: '/checkout',
    Cart: '/cart',
    Login: '/login',
    Admin: '/admin',
    Account: '/my-account',
    TourCategory: '/tour-category/:categoryName',
    Policy: '/policy',
    ToursSearch: '/tours/search',
    UserManagement: '/admin/users',
    UserEdit: '/admin/users/edit/:userId',
    EditProfile: '/admin/edit-profile',
    UserCreate: '/admin/users/create',
    Test: '/test',
    BTPV: '/btpv',
    HandBook: '/hand-book'
}

export { routes }